import axios from 'axios';
import config from '../config';

const GetAll = async (page, count, keyword) => {
    try {
        const token = localStorage.getItem("oojwt");
        const response = await axios.get(config.apiUrl + 'user-level/all?page=' + page + '&resultCount=' + count + '&keyword=' + keyword, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });
        if (response.status === 200) {
            console.log(response.data);
            return {
                status: 200,
                userLevels: response.data.userLevels,
                total: response.data.pagination.totalResults,
                totalPages: response.data.pagination.totalPages
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 401,
            message: error.response.data.message
        };

    }
}

//get by user level id
const GetById = async (id) => {
    try {
        const token = localStorage.getItem("oojwt");
        const response = await axios.get(config.apiUrl + 'user-level/get-by-id?id=' + id,
            {
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            });
        console.log(response.data);
        if (response.status === 200) {
            return {
                status: 200,
                userLevel: response.data.userLevel
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 401,
            message: error.response.data.message
        };

    }
}

const GetByLevelId = async (levelId, page, count, keyword) => {
    try {
        const token = localStorage.getItem("oojwt");
        const response = await axios.get(
            `${config.apiUrl}user-level/get-by-level-id?levelId=${levelId}&page=${page}&resultCount=${count}&keyword=${keyword}`,
            {
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            }
        );
        console.log("Response status:", response);
        if (response.status === 200) {
            return {
                status: 200,
                userLevels: response.data.userLevels,
                total: response.data.pagination.totalResults,
                totalPages: response.data.pagination.totalPages
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 401,
            message: error.response.data.message
        };

    }
};

//get by status
const GetByStatusAndLevelId = async (levelId, status, page, count, keyword) => {
    try {
        const token = localStorage.getItem("oojwt");
        const response = await axios.get(
            `${config.apiUrl}user-level/user-levels-by-status-and-level-id?levelId=${levelId}&status=${status}&page=${page}&resultCount=${count}&keyword=${keyword}`,
            {
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            }
        );
        console.log("Response status:", response);
        if (response.status === 200) {
            return {
                status: 200,
                userLevels: response.data.userLevels,
                total: response.data.pagination.totalResults,
                totalPages: response.data.pagination.totalPages
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 401,
            message: error.response.data.message
        };

    }
};


const UpdateUserLevel = async (id, remarks, givenDate) => {
    try {
        const data = new FormData();
        data.append("id", id);
        data.append("remarks", remarks);
        data.append("givenDate", givenDate);

        console.log("Data in service : " + data);

        const token = localStorage.getItem("oojwt");
        const response = await axios.post(config.apiUrl + 'user-level/update-status-and-given-date', data, {
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'multipart/form-data'
            }
        });

       
        if (response.status === 200) {
            return {
                status: 200,
                message: response.data.message,
                page: response.data.page
            };
        }
    } catch (error) {
        return {
            status: error.response.status,
            message: error.response.data.message
        };
    }
}


export { GetAll, GetByLevelId, GetByStatusAndLevelId, UpdateUserLevel, GetById };



